import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth';

// 解决导航栏中vue-router在3.0版本以上重复点击菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// 白名单路由,不需要权限的路由,产品首页
export const constantRoutes = [
    {
        path: '/homePage',
        name: 'homePage',
        component: resolve => require(['@/homeViews/zhuye'], resolve)
    },
    {
        path: '/joinus',
        name: 'joinus',
        component: resolve => require(['@/homeViews/joinus/joinus'], resolve)
    },
    {
        path: '/positiondetail',
        name: 'positiondetail',
        component: resolve => require(['@/homeViews/joinus/position-detail'], resolve)
    },
    {
        path: '/positionapply',
        name: 'positionapply',
        component: resolve => require(['@/homeViews/joinus/position-apply'], resolve)
    },
    {
        path: '/positionapplywait',
        name: 'positionapplywait',
        component: resolve => require(['@/homeViews/joinus/position-applywait'], resolve)
    },
    {
        path: '/aboutus',
        name: 'aboutus',
        component: resolve => require(['@/homeViews/aboutus'], resolve)
    },
    {
        path: '/aboutproduct',
        name: 'aboutproduct',
        component: resolve => require(['@/homeViews/aboutproduct'], resolve)
    },
    {
        path: '/aboutproduct2',
        name: 'aboutproduct2',
        component: resolve => require(['@/homeViews/aboutproduct2'], resolve)
    },
    {
        path: '/helpcentre',
        name: 'helpcentre',
        component: resolve => require(['@/homeViews/helpcentre'], resolve)
    },
    {
        path: '/newbull',
        name: 'newbull',
        component: resolve => require(['@/homeViews/newbull'], resolve)
    },
    {
        path: '/newbullDetail',
        name: 'newbullDetail',
        component: resolve => require(['@/homeViews/newbull/newbullDetail'], resolve)
    },
    {
        path: '/newbullDetails',
        name: 'newbullDetails',
        component: resolve => require(['@/homeViews/newbull/newbullDetails'], resolve)
    },
    {
        path: '/login',
        name: 'login',
        component: resolve => require(['@/components/logon/login'], resolve)
    },
    {
        path: '/regist',
        name: 'regist',
        component: resolve => require(['@/components/logon/regist'], resolve)
    },
    {
        path: '/forgot',
        name: 'forgot',
        component: resolve => require(['@/components/logon/forgot-pwd'], resolve)
    },
    {
        path: '*',
        name: '404',
        components: {
            default: resolve => require(['@/components/_404'], resolve),
            topbar: resolve => require(['@/components/main/topbar'], resolve),
            sidebar: resolve => require(['@/components/main/sidebar'], resolve)
        }
    }
]

// 需要登录之后的才能看到页面的基本路由
export const asyncBaseRoute = [
    { path: '/znx', component: resolve => require(['@/components/business/letter-news/znx'], resolve) },
    { path: '/db', component: resolve => require(['@/components/business/letter-news/db'], resolve) },
    { path: '/shade', component: resolve => require(['@/components/logon/shade'], resolve) },
    { path: '/index', name: 'index', component: resolve => require(['@/components/main/index'], resolve) },
    { path: '/index_treasure', component: resolve => require(['@/components/main/index-treasure'], resolve) },
    { path: '/index_guide',name:'index_guide', component: resolve => require(['@/components/main/index-guide'], resolve) },
    { path: '/index_business',name:'index_business', component: resolve => require(['@/components/main/index-business'], resolve) },
    { path: '/index_enterprise',name:'index_enterprise', component: resolve => require(['@/components/main/index-enterprise'], resolve) }
]

// 要添加的权限路由
export const asyncRoutes = [{
    path: '/',
    components: {
        default: resolve => require(['@/components/main/comtainer'], resolve),
        topbar: resolve => require(['@/components/main/topbar'], resolve),
        sidebar: resolve => require(['@/components/main/sidebar'], resolve)
    },
    redirect: '/homePage',
    children: []
}]

let router = new Router({
    mode: 'history',
    routes: constantRoutes.concat(asyncRoutes)
})

router.beforeEach((to, from, next) => { auth.validate(to, from, next) });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js